import {sortByKey} from 'presentation/utils';
import {makeGetExamsDistricts} from 'main/factories/usecases/private/booking-flow/remote-exams-booking/get-exams-districts-factory';
import {GetExamsDistrictsParams} from 'domain/usecases/private/booking-flow/exams/get-exams-districts';

async function getExamsDistricts(params: GetExamsDistrictsParams) {
	const districts = await makeGetExamsDistricts().get(params);

	const districtsSorted = sortByKey(districts?.content || [], 'district');

	return districtsSorted;
}

export {getExamsDistricts};
